export enum FunnelId {
  CONTACT_FORM = '27HgmeF9ARKZNueD1J4iOs',
}
